import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import ProtectedRoot from "../component/ProtectedRoot.js";
import DashboardPage from "../page/dashboard/Dashboard.js";
import AdminDashboardPage from "../page/dashboard/AdminDashboard.js";
import SignUpPage from "../page/Signup.js";
import LogInPage from "../page/Login.js";
import PrivacyPolicy from "../page/Privacy-Policy.js";
import TermsOfService from "../page/Terms-of-Service.js";
import DevicePage from "../page/Devices.js";
import SettingPage from "../page/Settings.js";
import DeviceForm from "../component/device-components/DeviceForm.js";
import CustomersPage from "../page/Customer.js";
import DeviceDetail from "../component/device-components/device-detail/DeviceDetail.js";
// import AlertConfigComponent from "../page/AlertConfig.js";
import SupportPage from "../page/Support.js";
import AlertPage from "../page/Alert.js";
import AlertNotificationDetail from "../component/alert-components/AlertNotificationDetail.js";
import Layout from "../component/Layout.js";
import AlertConfigDetail from "../component/alert-components/AlertConfigDetail.js";
// import AlertConfigEditor from "../component/alert-components/ConfigEditor.js";
import DefaultConfigDetail from "../component/alert-components/DefaultConfigDetail.js";
// import AlertConfigDetailTest from "../component/alert-components/AlertConfigDetaitTest.js";
import DeviceAlertConfigEditorWrapper from "../component/alert-components/AlertConfigEditorWrapper.js";
import DefaultConfigEditorWrapper from "../component/alert-components/DefaultConfigEditorWrapper.js";
import Warning from "../page/Warning.js";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Public Routes */}
      <Route path="/login" element={<LogInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />

      {/* Private Routes */}
      <Route path="/" element={<ProtectedRoot />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/devices" element={<DevicePage />} />
          <Route path="/devices/:pimios_id" element={<DeviceDetail />} />
          <Route path="/settings" element={<SettingPage />} />
          <Route path="/edit-unit/:id" element={<DeviceForm />} />
          <Route path="/customers" element={<CustomersPage />} />
          {/* <Route path="/alerts-config" element={<AlertConfigComponent />} /> */}
          <Route path="/alerts" element={<AlertPage />} />
          <Route
            path="/alerts/:alertId"
            element={<AlertNotificationDetail />}
          />
          <Route
            path="/alerts/config/:deviceId"
            element={<AlertConfigDetail />}
          />
          <Route
            path="/alerts/config/:deviceId/edit"
            element={<DeviceAlertConfigEditorWrapper />}
          />
          <Route
            path="/alerts/default-config/:deviceTypeId"
            element={<DefaultConfigDetail />}
          />
          <Route
            path="/alerts/default-config/:id/edit"
            element={<DefaultConfigEditorWrapper />}
          />
          <Route path="/warnings" element={<Warning />} />
          <Route path="/support" element={<SupportPage />} />
        </Route>
      </Route>
    </>
  )
);

export default router;
